/**
 * Constants for RegistrationPreview functionality
 * These flags control various preview behaviors and can be easily modified if requirements change
 */

/**
 * Controls whether form fields are interactive in preview mode
 * Set to true to disable all form interactions (recommended for preview)
 * Set to false to allow form filling in preview mode
 */
export const DISABLE_FORM_INTERACTION_IN_PREVIEW = true

/**
 * Controls whether select/dropdown fields are interactive in preview mode.
 * Kept separate from DISABLE_FORM_INTERACTION_IN_PREVIEW so dropdowns can be
 * opened to reveal their available options while text/date/checkbox fields
 * remain locked. Set to false to also lock down select fields.
 */
export const ENABLE_SELECT_INTERACTION_IN_PREVIEW = true

/**
 * Controls whether buttons are shown in preview mode
 * Set to true to hide action buttons in preview
 * Set to false to show action buttons
 */
export const HIDE_BUTTONS_IN_PREVIEW = false
